module.exports = __webpack_public_path__ + "img/blender.0769763a.png";